"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSelector = void 0;
var react_1 = __importDefault(require("react"));
var address_input_1 = require("../../components/address-input");
var smartystreets_1 = require("../../providers/smartystreets");
var smartystreets_international_1 = require("../../providers/smartystreets-international");
var SMARTY_STREETS_AUTOCOMPLETE_PUBLIC_KEY = 
// eslint-disable-next-line no-process-env
process.env.NODE_ENV === 'production' ? '29141061979865099' : '29141061880280959';
function AddressSelector(_a) {
    var accountUuid = _a.accountUuid, onChange = _a.onChange, selectedAddress = _a.selectedAddress, disabled = _a.disabled, width = _a.width;
    return (react_1.default.createElement(smartystreets_international_1.SmartyStreetsInternationalProvider, { apiKey: SMARTY_STREETS_AUTOCOMPLETE_PUBLIC_KEY },
        react_1.default.createElement(smartystreets_1.SmartyStreetsProvider, { apiKey: SMARTY_STREETS_AUTOCOMPLETE_PUBLIC_KEY },
            react_1.default.createElement(address_input_1.AddressInput, { accountUuid: accountUuid, selectedAddress: selectedAddress, onChange: onChange, disabled: disabled, width: width }))));
}
exports.AddressSelector = AddressSelector;
